// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#customers {
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

#customers td, #customers th {
  border: 1px solid black;
  padding: 8px;
}

#customers tr:nth-child(even) {
  background-color: white;
}

#customers tr:hover {
  background-color: white;
}

#customers th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: #17a2b8;
  color: white;
}

.material-icons {
  font-family: "Material Icons" !important;
}

.Deployement_dropDown {
  height: 32px;
  border-radius: 5px;
  padding-inline: 1%;
  position: relative;
  top: -17%;
  background-color: white;
  margin-left: 1px;
  margin-right: 2%;
  margin-block: 1%;
}

::ng-deep.Deployement_dropDown .mat-form-field-infix {
  border: 0 !important;
  height: 33px !important;
  font-size: 11px;
  padding-top: 8% !important;
  line-height: 13px !important;
}

::ng-deep.Deployement_dropDown .mat-form-field-appearance-outline .mat-form-field-wrapper {
  padding: 1%;
  margin: 1%;
}

::ng-deep.Deployement_dropDown .mat-form-field-label-wrapper {
  top: -1px !important;
}

.Deployement_default {
  height: 32px;
  border-radius: 5px;
  padding-inline: 1%;
  position: relative;
  top: 1%;
  background-color: white;
  margin-left: 1px;
  margin-right: 2%;
  margin-block: 1%;
}

::ng-deep.Deployement_default .mat-form-field-infix {
  border: 0 !important;
  height: 33px !important;
  font-size: 11px;
  padding-top: 8% !important;
  line-height: 19px !important;
}

::ng-deep.Deployement_default .mat-form-field-appearance-outline .mat-form-field-wrapper {
  padding: 1%;
  margin: 1%;
}

::ng-deep.Deployement_default .mat-form-field-label-wrapper {
  top: -24% !important;
}

.search_control_w700 {
  height: 30px !important;
  font-size: 12px !important;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) !important;
  padding-left: 1%;
  border-radius: 5px;
}

.w700_fontsize {
  font-size: 12px !important;
}

::ng-deep.Deployements_Dropdown .autocomplete-container .suggestions-container ul li a {
  padding: 14px 15px;
  display: block;
  text-decoration: none;
  cursor: pointer;
  color: rgba(0, 0, 0, 0.87);
  font-size: 11px !important;
}

.search_control_w700 {
  width: 100%;
}

.mt-2 {
  margin-top: 0.5rem;
}

.text-green {
  color: #5dd077 !important;
}

/* Single-row toolbar: keep Deployments, Search Jobs, and action buttons aligned horizontally */
.w700-jobs-toolbar {
  flex-wrap: nowrap;
}

.w700-jobs-deployment-form {
  width: 180px;
  margin: 0;
}

.w700-jobs-toolbar-actions {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./src/app/w700jobslist/w700jobslist.component.scss","webpack://./src/variables.scss"],"names":[],"mappings":"AAEA;EACE,yCAAA;EACA,yBAAA;EACA,WAAA;AADF;;AAIA;EACE,uBAAA;EACA,YAAA;AADF;;AAIC;EAA8B,uBAAA;AAA/B;;AAEC;EAAqB,uBAAA;AAEtB;;AAAA;EACE,iBAAA;EACA,oBAAA;EACA,gBAAA;EACA,yBAAA;EACA,YAAA;AAGF;;AADA;EACE,wCAAA;AAIF;;AACA;EACE,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AAEF;;AAAA;EACE,oBAAA;EACA,uBAAA;EACA,eAAA;EACA,0BAAA;EACA,4BAAA;AAGF;;AADA;EACE,WAAA;EACA,UAAA;AAIF;;AAFA;EACE,oBAAA;AAKF;;AAHA;EACE,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,OAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AAMF;;AAJA;EACE,oBAAA;EACA,uBAAA;EACA,eAAA;EACA,0BAAA;EACA,4BAAA;AAOF;;AALA;EACE,WAAA;EACA,UAAA;AAQF;;AANA;EACE,oBAAA;AASF;;AANA;EACE,uBC9EW;ED+EX,0BClFS;EDmFT,oDAAA;EACA,gBAAA;EACA,kBAAA;AASF;;AANA;EACE,0BCzFS;ADkGX;;AAJA;EACE,kBAAA;EACA,cAAA;EACA,qBAAA;EACA,eAAA;EACA,0BAAA;EACA,0BAAA;AAOF;;AAJA;EACE,WAAA;AAOF;;AAJA;EACE,kBAAA;AAOF;;AAJA;EACE,yBAAA;AAOF;;AAJA,+FAAA;AACA;EACE,iBAAA;AAOF;;AAJA;EACE,YAAA;EACA,SAAA;AAOF;;AAJA;EACE,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;AAOF","sourcesContent":["@import '../../variables.scss';\r\n\r\n#customers {\r\n  font-family: Arial, Helvetica, sans-serif;\r\n  border-collapse: collapse;\r\n  width: 100%;\r\n}\r\n\r\n#customers td, #customers th {\r\n  border: 1px solid black;\r\n  padding: 8px;\r\n}\r\n\r\n #customers tr:nth-child(even){background-color: white;}\r\n\r\n #customers tr:hover {background-color:white;}\r\n\r\n#customers th {\r\n  padding-top: 12px;\r\n  padding-bottom: 12px;\r\n  text-align: left;\r\n  background-color: #17a2b8;\r\n  color: white;\r\n}\r\n.material-icons{\r\n  font-family: 'Material Icons' !important;\r\n}\r\n\r\n\r\n\r\n.Deployement_dropDown{\r\n  height: 32px;\r\n  border-radius: 5px;\r\n  padding-inline: 1%;\r\n  position: relative;\r\n  top: -17%;\r\n  background-color: white;\r\n  margin-left: 1px;\r\n  margin-right: 2%;\r\n  margin-block: 1%;\r\n}\r\n::ng-deep.Deployement_dropDown  .mat-form-field-infix{\r\n  border: 0 !important;\r\n  height: 33px !important;\r\n  font-size: 11px;\r\n  padding-top: 8% !important;\r\n  line-height:13px !important;\r\n}\r\n::ng-deep.Deployement_dropDown .mat-form-field-appearance-outline .mat-form-field-wrapper{\r\n  padding: 1%;\r\n  margin: 1%;\r\n}\r\n::ng-deep.Deployement_dropDown .mat-form-field-label-wrapper{\r\n  top:-1px !important;\r\n}\r\n.Deployement_default{\r\n  height: 32px;\r\n  border-radius: 5px;\r\n  padding-inline: 1%;\r\n  position: relative;\r\n  top: 1%;\r\n  background-color: white;\r\n  margin-left: 1px;\r\n  margin-right: 2%;\r\n  margin-block: 1%;\r\n}\r\n::ng-deep.Deployement_default  .mat-form-field-infix{\r\n  border: 0 !important;\r\n  height: 33px !important;\r\n  font-size: 11px;\r\n  padding-top: 8% !important;\r\n  line-height:19px !important;\r\n}\r\n::ng-deep.Deployement_default .mat-form-field-appearance-outline .mat-form-field-wrapper{\r\n  padding: 1%;\r\n  margin: 1%;\r\n}\r\n::ng-deep.Deployement_default .mat-form-field-label-wrapper{\r\n  top:-24% !important;\r\n}\r\n\r\n.search_control_w700{\r\n  height:$inputHeight;\r\n  font-size:$fontsize;\r\n  box-shadow:0 2px 5px rgb(0 0 0 / 25%) !important;\r\n  padding-left: 1%;\r\n  border-radius: 5px;\r\n}\r\n\r\n.w700_fontsize{\r\n  font-size:$fontsize;\r\n}\r\n\r\n\r\n\r\n::ng-deep.Deployements_Dropdown .autocomplete-container .suggestions-container ul li a {\r\n  padding: 14px 15px;\r\n  display: block;\r\n  text-decoration: none;\r\n  cursor: pointer;\r\n  color: rgba(0, 0, 0, 0.87);\r\n  font-size: 11px !important;\r\n}\r\n\r\n.search_control_w700 {\r\n  width: 100%;\r\n}\r\n\r\n.mt-2 {\r\n  margin-top: 0.5rem;\r\n}\r\n\r\n.text-green {\r\n  color:  #5dd077 !important;\r\n}\r\n\r\n/* Single-row toolbar: keep Deployments, Search Jobs, and action buttons aligned horizontally */\r\n.w700-jobs-toolbar {\r\n  flex-wrap: nowrap;\r\n}\r\n\r\n.w700-jobs-deployment-form {\r\n  width: 180px;\r\n  margin: 0;\r\n}\r\n\r\n.w700-jobs-toolbar-actions {\r\n  display: flex;\r\n  flex-wrap: nowrap;\r\n  align-items: center;\r\n  white-space: nowrap;\r\n}","$btn-color: #17a0b4 !important;\r\n$fontsize: 12px !important;\r\n$btntextcolor: white !important;\r\n$btnHeight: 28px !important;\r\n$inputHeight:30px !important;\r\n$inputfontsize:11px !important;\r\n$primary:#004bff;\r\n// $modalHeaderTitleFont: ;\r\n@mixin modalheaderTtext {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
